import { StandardAppConfig } from './StandardAppConfig';
import { standardMessages } from './standardMessages';
import { get } from 'lodash';

export const getLabel = (
    appConfig: StandardAppConfig,
    pageName: string,
    fieldName: string,
    defaultCopy: React.ReactChild
) => appConfig.labels?.[pageName]?.[fieldName] ?? standardMessages(appConfig).labels?.[fieldName] ?? defaultCopy;

export const getHelpMessage = (
    appConfig: StandardAppConfig,
    pageName: string,
    fieldName: string,
    defaultCopy: React.ReactChild
) => appConfig.helpMessages?.[pageName]?.[fieldName] ?? standardMessages(appConfig).helpMessages?.[fieldName] ?? defaultCopy;

export const getErrorMessage = (
    appConfig: StandardAppConfig,
    pageName: string,
    fieldName: string,
    errorName: string,
    defaultCopy: React.ReactChild
) => {
    const archetype = appConfig.projectArchetype;
    const path = `errorMessages.${pageName}.${archetype}.${fieldName}.${errorName}`;
    return get(appConfig, path) ??
        get(standardMessages(appConfig), path) ??
        defaultCopy;
};
